import React from 'react';
import { BodyText, Divider } from '@placer-ui/components';
import styles from './or-divider.module.scss';

export const OrDivider = () => {
    return (
        <div className={styles.orDividerContainer}>
            <Divider type="header" />
            <BodyText color="secondary">OR</BodyText>
            <Divider type="header" />
        </div>
    );
};
